import objectHash from "object-hash";
import i18n from "../plugins/i18n";
const hostsDev = ["knapp-dev.jumptoday.group"];
const hostsLocal = ["localhost", "127.0.0.1"];
const hostStage = ['knapp.jumptoday.group'];

export default {
  currentUser(state) {
    return state.currentUser;
  },

  langShortcode(state) {
    return state.currentUser.language.shortcode;
  },

  getSelectedLangString(state) {
    return state.lang.currentString;
  },

  isMetricUnitSystem(state){
    return state.currentUser && state.currentUser.unitSystem === 'metric'
  },

  isSessionExpired(state){
    return state.sessionExpired;
  },
  selectedBundles(state){ 
    return state.selectedBundles;
  },
  showArticlePropertiesTabUnit(state){
    return state.showArticlePropertiesTabUnit;
  },
  batchList(state){
    return state.batchList;
  },
  showModalLanguage(state) {
    return state.lang.showModal;
  },
  getLanguages(state) { 
    return state.languages;
  },
  isValueChainProperitesFormValid(state){
    return state.valueChainProperties.isFormValid;
  },

  savedValueChainProperties(state){
    return state.valueChainProperties.saved;
  },

  isBundleAttribute(state){
    if(state.isBundleAttribute === null){
      return localStorage.getItem('isBundleAttribute');
    }
    return state.isBundleAttribute;
  },

  getTranslatedLanguages(state){
    if(!Array.isArray(state.languages)) return [];
    return state.languages.map(language => {
      return Object.assign(language, {
        label: i18n.t(`GLOBAL-LANG-${language.shortcode.toUpperCase()}`)
      });
    })
  },

  isPageTitleUpdated(state){
    return state.pageTitleUpdated;
  },

  isCurrentConditionBoxHidden(state){
    return (condition) => {
      const hash = objectHash(condition);
      const index = state.conditionBoxToggleList.findIndex((el) => el.hash === hash);
      if(index === -1) return false;
      return state.conditionBoxToggleList[index].status;
    }
  },
  envs(){
    return {
      isDev: hostsDev.includes(window.location.hostname),
      isLocal: hostsLocal.includes(window.location.hostname),
      isStage: hostStage.includes(window.location.hostname),
      isProd:
        !hostsDev.includes(window.location.hostname) &&
        !hostsLocal.includes(window.location.hostname) &&
        !hostStage.includes(window.location.hostname),
    };
  }
};
